export default {
	home: {
		name: ""
	},
	page_out_trade_no: "가맹점 주문 번호",
	_start_recording: "녹화 시작",
	_stop_recording: "녹화 종료",
	_switch_obj: "OBJ로 전환",
	_switch_gaussian: "Gaussian으로 전환",
	_switch_glb: "GLB로 전환",
	_model_has_no_obj: "이 모델에는 OBJ 모델이 없습니다",
	_model_has_no_gaussian: "이 모델에는 Gaussian 모델이 없습니다",
	_model_does_not_exist: "모델 파일이 존재하지 않습니다",
	"_no_photos!": "사진 없음",
	_image_loading_failed: "이미지 로드 실패",
	_no_gaussian_model_available: "Gaussian 모델이 없습니다",
	_no_normal_map_available: "모델 노멀 맵이 없습니다",
	"_model_loading_failed,_please_try_again_later":
		"모델 로드에 실패했습니다. 나중에 다시 시도해 주세요",
	"_obj_model_does_not_exist,_automatically_switched_to_gaussian_preview":
		"OBJ 모델이 존재하지 않아 Gaussian 미리보기로 자동 전환되었습니다",
	_original_uploaded_photo: "원본 업로드 사진",
	_effect_image: "효과 이미지",
	submit_modeling_model_file_not_ready:
		"모델 파일이 아직 준비되지 않았습니다. 잠시 후 다시 시도하거나 고객센터에 문의해 주세요.",
	finance_package_order_reverse: "패키지 정가 상계",
	finance_shop_red_reversal: "매장 상계",
	finance_dealer_red_reversal: "대리점 상계"
};
